import { render, staticRenderFns } from "./freeTips.vue?vue&type=template&id=81cde504&"
import script from "./freeTips.vue?vue&type=script&lang=js&"
export * from "./freeTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports